package Structs

import Utils.number_to_month

open class Debt(
    val date: String,
    val id: Int,
    var debt: Float,
    var paid: Float? = null,
    var type: Int? = null,
    var date_paid: String? = null,
    var date_updated: String? = null
): InformationBase() {
    override fun getConnectedDate(): String {
        return date
    }

    override fun getConnectedId(): Int {
        return id
    }

    override fun getConnectedEntId(): Int {
        return id
    }

    override fun getConnectedValue(): Float {
        return debt
    }

    override fun getConnectedName(): String {
        return ""
    }

    override fun toString(): String {
        return date.toString().split(" ").reversed().joinToString(" ")
    }

    fun toStringWithoutime(): String {
        return date.toString().split(" ")[0]
    }

    fun toStringHebrewMonth(): String {
        val d = this.toStringWithoutime()
        val month = d.split("-")[1]
        val hebrew_month = number_to_month[month.toInt()]
        val year = d.split("-")[0]
        return "$year-$hebrew_month"
    }

}
